// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Count,
  CountFromJSON,
  CountToJSON,
  Queue,
  QueueFromJSON,
  QueueToJSON,
  QueuePayload,
  QueuePayloadFromJSON,
  QueuePayloadToJSON,
  QueueUpdatePayload,
  QueueUpdatePayloadFromJSON,
  QueueUpdatePayloadToJSON,
  TCError,
  TCErrorFromJSON,
  TCErrorToJSON,
} from "../models";

export interface CreateQueueRequest {
  queuePayload?: QueuePayload;
}

export interface DeleteQueueRequest {
  id: number;
}

export interface GetQueueRequest {
  id: number;
}

export interface GetQueueCountRequest {
  company: number;
  filter?: string;
}

export interface GetQueuesRequest {
  company: number;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
}

export interface UpdateQueueRequest {
  id: number;
  queueUpdatePayload?: QueueUpdatePayload;
}

/**
 * no description
 */
export class QueuesApi extends runtime.BaseAPI {
  /**
   * Queue to add
   * Create a new queue
   */
  async createQueueRaw(
    requestParameters: CreateQueueRequest
  ): Promise<runtime.ApiResponse<Queue>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/queues`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: QueuePayloadToJSON(requestParameters.queuePayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QueueFromJSON(jsonValue)
    );
  }

  /**
   * Queue to add
   * Create a new queue
   */
  async createQueue(requestParameters: CreateQueueRequest): Promise<Queue> {
    const response = await this.createQueueRaw(requestParameters);
    return await response.value();
  }

  /**
   * Deletes a specific queue
   * Delete a queue
   */
  async deleteQueueRaw(
    requestParameters: DeleteQueueRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteQueue."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/queues/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Deletes a specific queue
   * Delete a queue
   */
  async deleteQueue(requestParameters: DeleteQueueRequest): Promise<any> {
    const response = await this.deleteQueueRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get details of specific queue
   * Get queue
   */
  async getQueueRaw(
    requestParameters: GetQueueRequest
  ): Promise<runtime.ApiResponse<Queue>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getQueue."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/queues/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QueueFromJSON(jsonValue)
    );
  }

  /**
   * Get details of specific queue
   * Get queue
   */
  async getQueue(requestParameters: GetQueueRequest): Promise<Queue> {
    const response = await this.getQueueRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get queues'count
   * Get count of queues
   */
  async getQueueCountRaw(
    requestParameters: GetQueueCountRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.company === null ||
      requestParameters.company === undefined
    ) {
      throw new runtime.RequiredError(
        "company",
        "Required parameter requestParameters.company was null or undefined when calling getQueueCount."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.company !== undefined) {
      queryParameters["company"] = requestParameters.company;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/queues/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Get queues'count
   * Get count of queues
   */
  async getQueueCount(requestParameters: GetQueueCountRequest): Promise<Count> {
    const response = await this.getQueueCountRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get list of currently running queues
   * Get list of queues
   */
  async getQueuesRaw(
    requestParameters: GetQueuesRequest
  ): Promise<runtime.ApiResponse<Array<Queue>>> {
    if (
      requestParameters.company === null ||
      requestParameters.company === undefined
    ) {
      throw new runtime.RequiredError(
        "company",
        "Required parameter requestParameters.company was null or undefined when calling getQueues."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.company !== undefined) {
      queryParameters["company"] = requestParameters.company;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/queues`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(QueueFromJSON)
    );
  }

  /**
   * Get list of currently running queues
   * Get list of queues
   */
  async getQueues(requestParameters: GetQueuesRequest): Promise<Array<Queue>> {
    const response = await this.getQueuesRaw(requestParameters);
    return await response.value();
  }

  /**
   * Queue to update
   * Updates a queue
   */
  async updateQueueRaw(
    requestParameters: UpdateQueueRequest
  ): Promise<runtime.ApiResponse<Queue>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling updateQueue."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/queues/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: QueueUpdatePayloadToJSON(requestParameters.queueUpdatePayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QueueFromJSON(jsonValue)
    );
  }

  /**
   * Queue to update
   * Updates a queue
   */
  async updateQueue(requestParameters: UpdateQueueRequest): Promise<Queue> {
    const response = await this.updateQueueRaw(requestParameters);
    return await response.value();
  }
}
